import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=unauth, obj=auth
  const [viewRole, setViewRole] = useState(null); // hr can switch view

  useEffect(() => {
    const token = localStorage.getItem("skx_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data);
        setViewRole(data.role);
      })
      .catch(() => {
        localStorage.removeItem("skx_token");
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("skx_token", data.token);
    setUser(data.user);
    setViewRole(data.user.role);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("skx_token");
    setUser(false);
    setViewRole(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, viewRole, setViewRole, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
